import { transparentize } from 'polished';
export var superRed = '#FF3347';
export var superRedA11y = '#DF1C2F';
export var blue2 = '#4B99E9';
export var blue1 = '#406599';
export var blue = blue1;
export var darkFormScoreBlue = '#77BDFF';
export var black = '#000000';
export var dark = '#191b1e';
export var slate6 = '#131416';
export var slate4 = '#111214';
export var slate3 = '#222529';
export var slate2pt5 = '#2F333A';
export var slate2 = '#4C525E';
export var slate1 = '#5A6474';
export var slateX = '#373B42';
export var gray6 = '#697180';
export var gray5 = '#8A8D91';
export var gray4 = '#A8ACB1';
export var gray3 = '#D2D5D9';
export var gray2 = '#E4E7EB';
export var gray1 = '#F5F7F9';
export var backgroundGray = gray2; // Keeping this variable in case the background changes in the future

export var white = '#FFFFFF';
export var inputErrorYellow = '#FACB3E';
export var inputErrorRed = '#E60017';
export var backgroundInputGray = transparentize(0.9, white);
export var backgroundHoverInputGray = transparentize(0.8, white);
export var disabledInputGray = transparentize(0.5, slate3);
export var darkGrayMedium = transparentize(0.5, gray5);
export var offBlack = '#181a1d';
export var mediumGray = '#777a81';
export var freeLight = '#85e0cb';
export var freeDark = '#1f7a65';